import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { WkAlfrescoApiService } from '../../../services/wk-alfresco-api.service';
import type { RequestParams } from '../../../types';

@Injectable({ providedIn: 'root' })
export class WkVersionService {
  constructor(private readonly alfrescoApi: WkAlfrescoApiService) {}

  getVersion(nodeId: string): Observable<any> {
    return from(
      this.alfrescoApi.callContentClientCustomApi({
        path: `alfresco/api/-default-/public/alfresco/versions/1/nodes/${nodeId}/extendedversions`,
        httpMethod: 'GET',
        contentTypes: ['application/json'],
        accepts: ['application/json'],
      })
    );
  }

  revertVersion(nodeId: string, versionId: string, data: any) {
    const requestParam: RequestParams = {
      httpMethod: 'POST',
      path: 'alfresco/s/wk/core/nodes/{nodeId}/versions/{versionId}/revert',
      pathParams: { nodeId, versionId },
      bodyParam: { majorVersion: data.isMajorVersion, comment: data.comment },
      contentTypes: ['application/json'],
      accepts: ['application/json'],
    };
    return from(this.alfrescoApi.callContentClientCustomApi(requestParam));
  }

  getNodeInformation(nodeId: string) {
    return from(
      this.alfrescoApi.nodesApi.getNode(nodeId, {
        include: ['permissions', 'path', 'isFavorite', 'allowableOperations'],
      })
    );
  }

  public getContributers(nodeId: string): Observable<any> {
    return from(
      this.alfrescoApi.callContentClientCustomApi({
        path: `alfresco/service/wk/core/documentClassifications/${nodeId}?property=lippproc:ceContributors`,
        httpMethod: 'GET',
        contentTypes: ['application/json'],
        accepts: ['application/json'],
      })
    ).pipe(
      catchError((error) => {
        console.error('Caught an error:', error.message);
        return of([]);
      })
    );
  }

  public getDocumentByNodeId(nodeId: string, version: string): Observable<any> {
    return from(
      this.alfrescoApi.callContentClientCustomApi({
        path: `alfresco/s/wk/nodes/${nodeId}/orchestrated-properties?fields=all&isVersioned=true&versionLabel=${version}`,
        httpMethod: 'GET',
        contentTypes: ['application/json'],
        accepts: ['application/json'],
      })
    ).pipe(
      catchError((error) => {
        console.error('Caught an error:', error.message);
        return of({
          content:
            'Something went wrong while processing your request. Please try again in a few minutes. If the problem continues, contact support.',
        });
      })
    );
  }
}
